/* Afroyla FALL CLEARANCE claim-deal LP — per-arm claim % swap (ab.hc.tools exp, 60% vs 55%, 10-14; port of the Skullette module).
 * Every claim number on the page (hero count-up target, reason paragraph "up to N% off") is a span tagged
 * [data-afd-claim]; this module is the ONE place that decides the number and writes it everywhere at once.
 * Needs window.AFD (core module, loaded first — core also holds startCountup(), which this module calls
 * instead of auto-running the count-up, so the hero number never flashes the wrong arm's value: it stays
 * visibility:hidden (see .afd[data-afd-claim-pending] in the CSS) until resolved here).
 *
 * window.__HCAB shape (read from the live ab.hc.tools bundle, hc-bundle-ab.js, 10-13): a singleton object
 * { ready: boolean, assignments: {<expId>: <variantId string>}, mode, get(expId), exposure(expId), ... },
 * plus a one-shot "hcab:ready" DOCUMENT event fired the first time `ready` flips true. assignments[expId] is
 * normally a plain variant-id string, but this module also accepts an object with a .variant/.id/.variantId
 * property defensively, in case a future ab.js version wraps it.
 * Blank section settings (claim_exp_id / claim_variant_map) → always claim_pct_default, no __HCAB wait at all
 * — this is the "today's behaviour" fallback the phase-08 plan requires.
 */
(function () {
  var A = window.AFD;
  if (!A) return;
  var root = A.root;
  var countEl = root.querySelector('[data-afd-countup]');
  var fallbackPct = Number(root.dataset.afdClaimDefault) || 60;
  var expId = root.dataset.afdClaimExp || '';
  var mapRaw = root.dataset.afdClaimMap || '';

  function parseVariantMap(raw) {
    var map = {};
    raw.split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length !== 2) return;
      var id = parts[0].trim();
      var pct = Number(parts[1].trim());
      if (id && !isNaN(pct)) map[id] = pct;
    });
    return map;
  }
  var variantMap = mapRaw.trim() ? parseVariantMap(mapRaw) : null;

  function applyPct(pct) {
    if (countEl) countEl.dataset.afdTarget = pct;
    root.querySelectorAll('[data-afd-claim]').forEach(function (el) {
      if (el === countEl) return;
      el.textContent = pct;
    });
    root.removeAttribute('data-afd-claim-pending');
    A.startCountup();
  }

  function extractVariantId(assigned) {
    if (typeof assigned === 'string') return assigned;
    if (assigned && typeof assigned === 'object') return assigned.variant || assigned.id || assigned.variantId || null;
    return null;
  }

  function resolveFromHCAB() {
    if (!expId || !variantMap) return null;
    var ab = window.__HCAB;
    if (!ab || !ab.assignments) return null;
    var variantId = extractVariantId(ab.assignments[expId]);
    if (!variantId || !variantMap.hasOwnProperty(variantId)) return null;
    return variantMap[variantId];
  }

  function finish() {
    var pct = resolveFromHCAB();
    applyPct(pct != null ? pct : fallbackPct);
  }

  // No experiment configured on this section instance → skip the __HCAB wait entirely (today's behaviour).
  if (!expId || !variantMap) { finish(); return; }

  var settled = false;
  function settleOnce() { if (settled) return; settled = true; finish(); }

  if (window.__HCAB && window.__HCAB.ready) { settleOnce(); return; }
  document.addEventListener('hcab:ready', settleOnce, { once: true });
  setTimeout(settleOnce, 1500); // ab.js never became ready (blocked/slow network) → fall back, don't hang the page
})();
